import React, { useState } from 'react';
import { FaWhatsapp, FaTiktok } from "react-icons/fa";
import { 
  Facebook, Twitter, Instagram, Youtube, 
  Mail, MapPin, Phone, Shield, Truck, ArrowRight 
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';
 
const FooterSection = ({ config = {} }) => {
  const token = localStorage.getItem('token');
  const [user, setUser] = useState(null);
  const [links,setLinks]=useState({
    Twitter:'https://whatsapp.com/channel/0029Vb69bLY8aKvMUB4GPd2',
    Facebook:'https://www.tiktok.com/@junisaproductsbackup?_r=1&_t=ZS-94e8mTYZCMb',
    Instagram:'https://www.instagram.com/junisa_product?igsh=N3Z4a2ZqbDV2eDc5'
  });
  const defaultConfig = {
  preset: 'minimal-clean',
  brandName: 'JUNISA',
  brandDesc: 'Premium quality meets modern design. Your destination for timeless style.',
  newsletterTitle: 'Stay in the Loop',
  newsletterDesc: 'Subscribe to get special offers, free giveaways, and exclusive deals.',
  ctaText: 'Subscribe',
  socialLinks: ['Facebook', 'Instagram', 'Twitter'],
  shopLinks: ['Baseball Caps', 'Hats', 'Umbrella', 'Hand Bags'],
  serviceLinks: ['Contact Us', 'Help Center', 'Our Stores', 'FAQ'],
  companyLinks: ['Our Stores'],
  contact: {
    email: 'orders@junisaproducts.com',
    phone: '+254 705 572 556',
    address: 'Nairobi, Kamukunji, Jubilee Complex Shop G8',
  },
  trustBadges: ['Secure Payment', 'Fast Shipping'],
  paymentIcons: ['Mpesa'],
  bottomText: '© 2026 JUNISA. All rights reserved.',
  bottomLegalLinks: [], 
  customStyles: {
    container: {
      padding: 'py-12 md:py-16',
      background: 'bg-gray-900',
      textColor: 'rgb(240,90,42)',
      linkColor: '#ffffff',
      linkHover: '#ffffff',
      newsletterBg: 'bg-gray-800',
    },
  },
  columns: {
    mobileCols: 2,
    desktopCols: 4,
  },
  devMode: true
};

  const finalConfig = { ...defaultConfig, ...config };
  const {
    preset,
    brandName,
    brandDesc,
    newsletterTitle,
    newsletterDesc,
    ctaText,
    socialLinks,
    shopLinks,
    serviceLinks,
    companyLinks,
    contact,
    trustBadges,
    paymentIcons,
    bottomText,
    bottomLegalLinks, // NEW
    customStyles,
    columns,
  } = finalConfig;

  const [email, setEmail] = useState('');
    const navigate = useNavigate();
  // ── Container styling ──────────────────────────────────────────────
  const containerClasses = [];
  const containerStyle = {};

  const bgValue = customStyles?.container?.background || 'bg-gray-900';

  if (bgValue.startsWith('bg-')) {
    containerClasses.push(bgValue);
  } else {
    containerStyle.background = bgValue;
    if (bgValue.includes('url(')) {
      containerStyle.backgroundSize = 'cover';
      containerStyle.backgroundPosition = 'center';
      containerStyle.backgroundRepeat = 'no-repeat';
    }
  }

  if (customStyles?.container?.padding) {
    containerClasses.push(customStyles.container.padding);
  }


const handleNavigate = (url) => {
   
   
    if (url === 'shop' || url.trim().toLowerCase() === 'shop') navigate(`/${url}/all`);
    else if (url === 'MainPage_s' || url === 'home' || url.trim().toLowerCase() === 'home') navigate(`/${url}`);
    else if (url === 'Orders') navigate(`/${url}`);
    else if (url === 'Authentication') {
      if (user?.sessionKey === token) navigate(`/Orders`);
      else navigate(`/${url}`);
    } else if (url === 'contact-us' || url.trim().toLowerCase() === 'contact us'  || url.trim().toLowerCase() === 'support') navigate(`/Contact`);
    
    else if (url === 'Account' ) navigate(`/myAccount`);
    else if (url === 'Wishlist') navigate(`/Wishlist`);
    else if (url === 'help-center' || url.trim().toLowerCase() === 'help center' || url.trim().toLowerCase() === 'faq') navigate(`/Help`);
    else if (url === 'our-stores' || url.trim().toLowerCase() === 'our stores') navigate(`/Stores`);
    else navigate(`/i/${url}`);
  };

  const finalContainerClass = containerClasses.join(' ');

  // ── DESIGN 1: Comprehensive ────────────────────────────────────────
  const Comprehensive = () => (
    <footer className={`${finalContainerClass} text-white`} style={containerStyle}>
      {/* Newsletter */}
      <div className="border-b border-gray-800/50">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-12 md:py-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl md:text-3xl font-bold mb-2" style={{ color: customStyles?.container?.textColor }}>
                {newsletterTitle}
              </h3>
              <p className="text-sm" style={{ color: customStyles?.container?.linkColor }}>
                {newsletterDesc}
              </p>
            </div>
            <div>
              <div className="flex flex-col sm:flex-row gap-3">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="flex-1 px-6 py-4 rounded-full border text-white placeholder-gray-400 focus:outline-none focus:border-gray-500 transition-all"
                  style={{
                    backgroundColor: customStyles?.container?.newsletterBg,
                    borderColor: customStyles?.container?.linkColor,
                    color: customStyles?.container?.textColor,
                  }}
                />
                <button
                  className="px-8 py-4 rounded-full font-semibold transition-colors flex items-center justify-center gap-2 whitespace-nowrap"
                  style={{
                    backgroundColor: customStyles?.container?.textColor,
                    color: customStyles?.container?.linkColor || '#111827',
                  }}
                >
                  {ctaText}
                  <ArrowRight className="w-5 h-5" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-12 md:py-16">
        <div className={`grid grid-cols-${columns?.mobileCols || 2} md:grid-cols-${columns?.desktopCols || 5} gap-8 mb-12`}>
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <h2 className="text-2xl font-bold mb-4" style={{ color: customStyles?.container?.textColor }}>
              {brandName}
            </h2>
            <p className="text-sm mb-6" style={{ color: customStyles?.container?.linkColor }}>
              {brandDesc}
            </p>
            <div className="flex gap-3">
              {socialLinks.map((platform, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-10 cursor-pointer h-10 rounded-full flex items-center justify-center transition-colors hover:opacity-80"
                  style={{
                    backgroundColor: customStyles?.container?.newsletterBg,
                    color: customStyles?.container?.textColor,
                  }}
                >
                  {platform === 'Facebook' && <FaTiktok className="w-5 h-5" />}
                  {platform === 'Instagram' && <Instagram className="w-5 h-5" />}
                  {platform === 'Twitter' && <FaWhatsapp className="w-5 h-5" />}
                 
                </a>
              ))}
            </div>
          </div>

          {/* Shop */}
          <div>
            <h3 className="font-semibold mb-4" style={{ color: customStyles?.container?.textColor }}>Shop</h3>
            <ul className="space-y-3 text-sm">
              {shopLinks.map((link, i) => (
                <li key={i}>
                  <a onClick={()=>navigate('/Shop/'+link)} className="transition-colors cursor-pointer hover:underline" style={{ color: customStyles?.container?.linkColor }}>
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Customer Service */}
          <div>
            <h3 className="font-semibold mb-4" style={{ color: customStyles?.container?.textColor }}>Customer Service</h3>
            <ul className="space-y-3 text-sm">
              {serviceLinks.map((link, i) => (
                <li key={i} >
                  <a onClick={()=>handleNavigate(link)}  className="transition-colors cursor-pointer hover:underline" style={{ color: customStyles?.container?.linkColor }}>
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold mb-4" style={{ color: customStyles?.container?.textColor }}>Company</h3>
            <ul className="space-y-3 text-sm">
              {companyLinks.map((link, i) => (
                <li key={i} >
                  <a onClick={()=>handleNavigate(link)}  className="transition-colors cursor-pointer hover:underline" style={{ color: customStyles?.container?.linkColor }}>
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-semibold mb-4" style={{ color: customStyles?.container?.textColor }}>Get in Touch</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2">
                <Mail className="w-4 h-4 mt-0.5" style={{ color: customStyles?.container?.linkColor }} />
                <span style={{ color: customStyles?.container?.linkColor }}>{contact.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <Phone className="w-4 h-4 mt-0.5" style={{ color: customStyles?.container?.linkColor }} />
                <span style={{ color: customStyles?.container?.linkColor }}>{contact.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-0.5" style={{ color: customStyles?.container?.linkColor }} />
                <span style={{ color: customStyles?.container?.linkColor }}>{contact.address}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Trust Badges & Payment Icons */}
        <div className="border-t border-gray-800/50 pt-8">
          <div className="max-w-7xl mx-auto px-6 md:px-8 flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex items-center gap-6 flex-wrap justify-center md:justify-start">
              {trustBadges.map((badge, i) => (
                <div key={i} className="flex items-center gap-2 text-sm" style={{ color: customStyles?.container?.linkColor }}>
                  {badge === 'Secure Payment' && <Shield className="w-5 h-5" />}
                  {badge === 'Free Shipping' && <Truck className="w-5 h-5" />}
                  <span>{badge}</span>
                </div>
              ))}
            </div>
            <div className="flex gap-3">
              {paymentIcons.map((icon, i) => (
                <div
                  key={i}
                  className="w-12 h-8 rounded flex items-center justify-center text-xs font-bold"
                  style={{
                    backgroundColor: customStyles?.container?.newsletterBg,
                    color: customStyles?.container?.linkColor,
                  }}
                >
                  {icon}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800/50">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm" style={{ color: customStyles?.container?.linkColor }}>
            <p>{bottomText}</p>
            <div className="flex gap-6 flex-wrap justify-center md:justify-end">
              {bottomLegalLinks.map((link, i) => (
                <a
                  key={i}
                  href="#"
                  className="hover:underline"
                  style={{ color: customStyles?.container?.linkColor }}
                >
                  {link}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );

  // ── DESIGN 2: Minimal Clean ────────────────────────────────────────
  const MinimalClean = () => (
    <footer className={`${finalContainerClass} border-t`} style={containerStyle}>
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-12 md:py-16">
        <div className={`grid grid-cols-${columns?.mobileCols || 2} md:grid-cols-${columns?.desktopCols || 6} gap-8 mb-12`}>
          {/* Brand + Newsletter */}
          <div className="col-span-2">
            <h2 className="text-2xl font-bold mb-4" style={{ color: customStyles?.container?.textColor || '#111827' }}>
              {brandName}
            </h2>
            <p className="text-sm mb-6 max-w-xs" style={{ color: customStyles?.container?.linkColor || '#4b5563' }}>
              {brandDesc}
            </p>

            <div>
              <label className="text-sm font-medium mb-2 block" style={{ color: customStyles?.container?.textColor || '#111827' }}>
                Newsletter
              </label>
              <div className="flex gap-2">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Your email"
                  className="flex-1 px-4 py-2 border rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-gray-900"
                  style={{
                    backgroundColor: customStyles?.container?.newsletterBg || '#f9fafb',
                    color: customStyles?.container?.textColor || '#111827',
                    borderColor: customStyles?.container?.linkColor || '#d1d5db',
                  }}
                />
                <button
                  className="bg-gray-900 text-white px-4 py-2 rounded-lg hover:bg-gray-800 transition-colors"
                  style={{ backgroundColor: customStyles?.container?.textColor || '#111827' }}
                >
                  <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>

          {/* Shop */}
          <div>
            <h3 className="font-semibold mb-4 text-sm" style={{ color: customStyles?.container?.textColor || '#111827' }}>Shop</h3>
            <ul className="space-y-3 text-sm">
              {shopLinks.map((link, i) => (
                <li key={i}>
                  <a href="#" className="hover:underline" style={{ color: customStyles?.container?.linkColor || '#4b5563' }}>
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Help */}
          <div>
            <h3 className="font-semibold mb-4 text-sm" style={{ color: customStyles?.container?.textColor || '#111827' }}>Help</h3>
            <ul className="space-y-3 text-sm">
              {serviceLinks.map((link, i) => (
                <li key={i}>
                  <a href="#" className="hover:underline" style={{ color: customStyles?.container?.linkColor || '#4b5563' }}>
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Company */}
          <div>
            <h3 className="font-semibold mb-4 text-sm" style={{ color: customStyles?.container?.textColor || '#111827' }}>Company</h3>
            <ul className="space-y-3 text-sm">
              {companyLinks.map((link, i) => (
                <li key={i}>
                  <a href="#" className="hover:underline" style={{ color: customStyles?.container?.linkColor || '#4b5563' }}>
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="font-semibold mb-4 text-sm" style={{ color: customStyles?.container?.textColor || '#111827' }}>Follow</h3>
            <div className="flex gap-3">
              {socialLinks.map((platform, i) => (
                <a
                  key={i}
                  href={links['platform']}
                  target='_blank'
                  className="w-9 h-9 cursor-pointer rounded-full flex items-center justify-center transition-colors hover:bg-gray-900 hover:text-white"
                  style={{
                    backgroundColor: customStyles?.container?.newsletterBg || '#e5e7eb',
                    color: customStyles?.container?.linkColor || '#4b5563',
                  }}
                >
                 {platform === 'Facebook' && <FaTiktok className="w-4 h-4" />}
                  {platform === 'Instagram' && <Instagram className="w-4 h-4" />}
                  {platform === 'Twitter' && <FaWhatsapp className="w-4 h-4" />}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-sm">
          <p style={{ color: customStyles?.container?.linkColor || '#4b5563' }}>{bottomText}</p>
          <div className="flex gap-6 flex-wrap">
            {bottomLegalLinks.map((link, i) => (
              <a
                key={i}
                href="#"
                className="hover:underline"
                style={{ color: customStyles?.container?.linkColor || '#4b5563' }}
              >
                {link}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );

  // ── DESIGN 3: Compact CTA ──────────────────────────────────────────
  const CompactCTA = () => (
    <footer className={finalContainerClass} style={containerStyle}>
      {/* Big CTA */}
      <div className={`${customStyles?.container?.newsletterBg || 'bg-gradient-to-r from-gray-900 to-gray-800'} text-white py-12 md:py-16`}>
        <div className="max-w-7xl mx-auto px-6 md:px-8 text-center max-w-3xl mx-auto">
          <h3 className="text-2xl md:text-3xl font-bold mb-4" style={{ color: customStyles?.container?.textColor }}>
            Join Our Community
          </h3>
          <p className="mb-8" style={{ color: customStyles?.container?.linkColor || '#d1d5db' }}>
            Get exclusive access to new arrivals, special offers, and insider news.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center max-w-md mx-auto">
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="flex-1 px-6 py-3 rounded-lg bg-white/10 backdrop-blur-sm border border-white/20 placeholder-gray-400 focus:outline-none focus:border-white/40"
              style={{ color: customStyles?.container?.textColor || '#ffffff' }}
            />
            <button
              className="bg-white px-8 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
              style={{
                color: customStyles?.container?.textColor || '#111827',
                backgroundColor: customStyles?.container?.linkHover || '#ffffff',
              }}
            >
              {ctaText}
            </button>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-12">
        <div className={`grid grid-cols-${columns?.mobileCols || 2} sm:grid-cols-3 md:grid-cols-${columns?.desktopCols || 5} gap-8 mb-10`}>
          <div>
            <h4 className="font-semibold mb-4 text-sm" style={{ color: customStyles?.container?.textColor || '#111827' }}>Products</h4>
            <ul className="space-y-2 text-sm">
              {shopLinks.map((link, i) => (
                <li key={i}>
                  <a href="#" className="hover:underline" style={{ color: customStyles?.container?.linkColor || '#4b5563' }}>{link}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-sm" style={{ color: customStyles?.container?.textColor || '#111827' }}>Support</h4>
            <ul className="space-y-2 text-sm">
              {serviceLinks.map((link, i) => (
                <li key={i}>
                  <a href="#" className="hover:underline" style={{ color: customStyles?.container?.linkColor || '#4b5563' }}>{link}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-sm" style={{ color: customStyles?.container?.textColor || '#111827' }}>Company</h4>
            <ul className="space-y-2 text-sm">
              {companyLinks.map((link, i) => (
                <li key={i}>
                  <a href="#" className="hover:underline" style={{ color: customStyles?.container?.linkColor || '#4b5563' }}>{link}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-sm" style={{ color: customStyles?.container?.textColor || '#111827' }}>Legal</h4>
            <ul className="space-y-2 text-sm">
              {bottomLegalLinks.map((link, i) => (
                <li key={i}>
                  <a href="#" className="hover:underline" style={{ color: customStyles?.container?.linkColor || '#4b5563' }}>{link}</a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-4 text-sm" style={{ color: customStyles?.container?.textColor || '#111827' }}>Social</h4>
            <div className="flex gap-3 flex-wrap">
              {socialLinks.map((platform, i) => (
                <a
                  key={i}
                   href={links['platform']}
                  target='_blank'
                  className="w-9 h-9 cursor-pointer rounded-full flex items-center justify-center transition-colors hover:opacity-80"
                  style={{
                    backgroundColor: customStyles?.container?.newsletterBg || '#e5e7eb',
                    color: customStyles?.container?.linkColor || '#4b5563',
                  }}
                >
                {platform === 'Facebook' && <FaTiktok className="w-4 h-4" />}
                  {platform === 'Instagram' && <Instagram className="w-4 h-4" />}
                  {platform === 'Twitter' && <FaWhatsapp className="w-4 h-4" />}
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-sm">
          <div className="flex items-center gap-4 flex-wrap">
            <p style={{ color: customStyles?.container?.linkColor || '#4b5563' }}>{bottomText}</p>
            <div className="flex gap-2 flex-wrap">
              {paymentIcons.map((icon, i) => (
                <div
                  key={i}
                  className="w-12 h-8 rounded flex items-center justify-center text-xs font-bold"
                  style={{
                    backgroundColor: customStyles?.container?.newsletterBg || '#e5e7eb',
                    color: customStyles?.container?.linkColor || '#4b5563',
                  }}
                >
                  {icon}
                </div>
              ))}
            </div>
          </div>
          <div className="flex gap-4 flex-wrap">
            {bottomLegalLinks.map((link, i) => (
              <a
                key={i}
                href="#"
                className="hover:underline"
                style={{ color: customStyles?.container?.linkColor || '#4b5563' }}
              >
                {link}
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );

  return (
    <>
      {preset === 'comprehensive' && <Comprehensive />}
      {preset === 'minimal-clean' && <MinimalClean />}
      {preset === 'compact-cta' && <CompactCTA />}
    </>
  );
};

export default FooterSection;